import React from "react";
import { PageHeader } from "./PageHeader";
import { DataBox } from "./DataBox";
// import { BorrowPrint } from "@/components/ScaniaPrint/borrowPrint";
import { BorrowPrints } from "./BorrowPrint"
import { useStockOutAndInListModel } from "../stockOutAndInListModel";
export default () => {
    const { borrowPrint: { visible, type } } = useStockOutAndInListModel()

    return (
        <>
            <PageHeader />
            <DataBox />
            {visible && <BorrowPrints />}
        </>
    )
}